import {getFloors} from './getFloors';
import {parseSearchString} from '../../../utils/convertation/parseSearchString';
import {pluralNumber} from '../../../utils/numerals/pluralNumber';
import {stringifySearchParameters} from '../../../utils/convertation/stringifySearchParameters';
import {updateCriteo} from '../../common/criteo';

/* Сдвигает изображение этажа, если его перекрывает легенда */
/* view - figure, которая растянута на всю высоту окна */
const offsetLegend = ( chooserSection, view, complexId = null ) => {
	if ( chooserSection && view )
	{
		const legend = chooserSection.querySelector( 'ul.legend' );
		const svgChildren = view.querySelectorAll( 'svg > *' );
		
		let topLegendOffset = 0;
		if ( complexId == '11456' )
		{
			topLegendOffset = 20;
		}
		
		if ( legend && svgChildren.length > 0 )
		{
			const viewCoords = view.getBoundingClientRect();
			const legendCoords = legend.getBoundingClientRect();
			const legendTopPoint = legendCoords.y - topLegendOffset;
			let svgBootomPoint = 0;
			
			svgChildren.forEach( ( child ) => {
				const childCoords = child.getBoundingClientRect();
				const childBottomPoint = childCoords.y + childCoords.height;
				
				if ( childBottomPoint > svgBootomPoint )
				{
					svgBootomPoint = childBottomPoint;
				}
			} );
			
			if ( svgBootomPoint > legendTopPoint || view.style.maxHeight )
			{
				view.style.maxHeight = `${legendTopPoint - viewCoords.y}px`;
			}
		}
	}
};

export const initVisualChooser = () => {
	const chooserSection = document.querySelector( 'section.chooser' );

	if ( !chooserSection )
	{
		return;
	}

	const view = chooserSection.querySelector( 'figure' );

	if ( !view )
	{
		return;
	}

	const tooltip = chooserSection.querySelector( 'div.tooltip' );
	const componentID = chooserSection.id;
	const searchParameters = parseSearchString( location.search );
	const fullSearchParameters = Object.assign( {}, searchParameters );
	let chooserData, tooltipHeight;

	const getData = ( url ) => {
		window.fetch( url, {
			method: 'GET',
			credentials: 'same-origin',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
			}
		} )
			.then( response => response.json() )
			.then( ( msg ) => {
				chooserData = msg.components[componentID];
				if ( tooltip )
				{
					tooltip.style.display = '';
				}

				if ( chooserData.floor )
				{
					showFloor();
				}
				else if ( chooserData.building )
				{
					showBuilding();
				}
				else if ( chooserData.complex )
				{
					showComplex();
				}

				const info = chooserSection.querySelector( 'li.info' );
				if ( info )
				{
					info.addEventListener( 'click', () => {
						location.href = location.pathname.replace( 'apartments/', '' );
					} );
				}

				chooserSection.querySelector( 'li.complex' ).addEventListener( 'click', selectComplex );
				chooserSection.querySelector( 'li.building' ).addEventListener( 'click', selectBuilding );
				chooserSection.classList.remove( 'loading' );
			} );
	};

	const handleResize = () => {
		if ( window.innerWidth < 956 && !chooserSection.classList.contains( 'favourites' ) )
		{
			location.href = '?type=param';
		}
		
		if ( window.innerWidth < window.innerHeight )
		{
			chooserSection.classList.add( 'vertical' );
		}
		else
		{
			chooserSection.classList.remove( 'vertical' );
		}

		placeLabels();
	};
	
	const hideTooltip = () => {
		if ( view.querySelector( 'rect' ) )
		{
			view.querySelector( 'rect' ).style.opacity = 0;
		}

		if ( view.querySelector( `ul.labels li.hide` ) )
		{
			view.querySelector( `ul.labels li.hide` ).classList.remove( 'hide' );
		}
		
		tooltip.style.display = '';
	};

	const highlightApartment = ( evt ) => {
		const requestedID = evt.target.id.replace( 'APT-', '' );
		const apartment = chooserData.floor.rooms.find( ( room ) => room['position_on_floor'] === requestedID );

		apartment.on_sale ? tooltip.classList.add( 'sale' ) : tooltip.classList.remove( 'sale' );

		tooltip.querySelector( 'span' ).innerHTML = '№&nbsp;' + apartment.number;
		tooltip.querySelector( 'h2' ).innerHTML = apartment.title;
		tooltip.querySelector( 'p' ).innerHTML = apartment['hide_price'] ? '' : apartment.price + '&nbsp;₽';
		tooltip.querySelector( 'table' ).innerHTML = '';
		tooltip.style.display = 'block';
		moveTooltip( evt );
		updateCriteo( apartment.id, 'viewItem' );
	};
	
	const highlightBuilding = ( evt ) => {
		const building = evt.target;
		const currentPath = building.getAttribute( 'd' );
		
		const premisesCount = parseInt( building.dataset.rooms, 10 );
		const premisesCountInfo = premisesCount > 0
			? `${premisesCount}&nbsp;${pluralNumber( building.dataset.rooms, 'квартира', 'квартиры', 'квартир' )} в&nbsp;продаже`
			: `Нет в продаже`;

		view.querySelector( 'rect' ).style.opacity = 1;
		view.querySelector( 'mask path' ).setAttribute( 'd', currentPath );
		tooltip.querySelector( 'h2' ).innerHTML = `${building.dataset.title} <span>${building.dataset.deadline}</span>`;
		tooltip.querySelector( 'p' ).innerHTML = premisesCountInfo;
		tooltip.querySelector( 'table' ).innerHTML = '';
		tooltip.style.display = 'block';
		moveTooltip( evt );
		view.querySelector( `ul.labels li[data-id="${evt.target.dataset.id}"]` ).classList.add( 'hide' );
	};

	const highlightFloor = ( evt ) => {
		const floor = evt.target;
		const typesObject = JSON.parse( floor.dataset.types.replace( ',}', '}' ) );
		let types = '';

		tooltip.querySelector( 'h2' ).innerHTML = `${floor.dataset.floorTitle} <span>${floor.dataset.rooms}&nbsp;${pluralNumber( floor.dataset.rooms, 'квартира', 'квартиры', 'квартир' )} в&nbsp;продаже</span>`;
		tooltip.querySelector( 'p' ).innerHTML = '';

		Object.keys( typesObject ).forEach( ( it ) => {
			types += `<tr><td>${it}</td><td>${typesObject[it]}</td></tr>`;
		} );

		tooltip.querySelector( 'table' ).innerHTML = types;
		tooltip.style.display = 'block';
		moveTooltip( evt );
	};

	const moveTooltip = ( evt ) => {
		if ( window.innerWidth < 956 )
		{
			return;
		}

		tooltipHeight = tooltip.offsetHeight;

		if ( tooltipHeight + 20 > evt.pageY - 88 )
		{
			tooltip.classList.add( 'to-bottom' );
		}
		else
		{
			tooltip.classList.remove( 'to-bottom' );
		}

		tooltip.style.top = evt.pageY - 88 + 'px';
		tooltip.style.left = evt.pageX + 'px';
	};

	const placeLabels = () => {
		if ( chooserSection.dataset.step !== 'complex' )
		{
			return;
		}
		
		const viewRect = view.getBoundingClientRect();
		
		Array.from( view.querySelectorAll( 'ul.labels li' ) ).forEach( ( it ) => {
			const circleRect = view.querySelector( `circle#BLD-${it.dataset.id}` ).getBoundingClientRect();

			it.style.top = circleRect.y + ( circleRect.width / 2 ) - viewRect.y + 'px';
			it.style.left = circleRect.x + ( circleRect.height / 2 ) - viewRect.x + 'px';
		} );
	};

	const selectApartment = ( evt ) => {
		const requestedID = evt.target.id.replace( 'APT-', '' );
		const apartment = chooserData.floor.rooms.find( ( room ) => room['position_on_floor'] === requestedID );

		location.href = location.pathname + apartment.id + '/';
	};

	const selectBuilding = ( evt, keepFloorParameter ) => {
		evt.preventDefault();

		if ( evt.target.dataset.disabled )
		{
			return
		}

		if ( evt.target.dataset.id )
		{
			searchParameters.building = evt.target.dataset.id;
			fullSearchParameters.building = evt.target.dataset.id;
		}

		if ( !keepFloorParameter )
		{
			delete searchParameters.floor;
			delete fullSearchParameters.floor;
		}

		selectStep();
	};

	const selectComplex = ( evt ) => {
		evt.preventDefault();
		delete searchParameters.floor;
		delete fullSearchParameters.floor;
		delete searchParameters.building;
		delete fullSearchParameters.building;
		fullSearchParameters.complex = chooserSection.dataset.complex;
		selectStep();
	};

	const selectFloor = ( evt ) => {
		searchParameters.floor = evt.target ? evt.target.dataset.floor : evt;
		fullSearchParameters.floor = evt.target ? evt.target.dataset.floor : evt;
		selectStep();
	};

	const selectStep = () => {
		window.history.pushState( {}, document.querySelector( 'head title' ).innerHTML, location.pathname + stringifySearchParameters( searchParameters ) );
		getData( location.pathname + stringifySearchParameters( fullSearchParameters ) );
		chooserSection.classList.add( 'loading' );
	};

	const showBuilding = () => {
		chooserSection.dataset.step = searchParameters.building ? 'building' : 'complex';
		chooserSection.querySelector( 'a.back' ).href = searchParameters.building ? '' : `/complex/dom-u-karetnogo/`;
		chooserSection.querySelector( 'li.info' ).innerHTML = `${chooserData.building.breadcrumbs[0].title}`;
		chooserSection.querySelector( 'li.complex' ).innerHTML = searchParameters.building ? 'Выбор очереди' : '';
		chooserSection.querySelector( 'li.building' ).innerHTML = '';
		chooserSection.querySelector( 'span.title' ).innerHTML = 'этаж';
		chooserSection.querySelector( 'span.current-location' ).innerHTML = searchParameters.building ? chooserData.building.title : `Дом у Каретного`;
		view.innerHTML = chooserData.building.rendered;
		
		if ( searchParameters.building )
		{
			if ( chooserSection.querySelector( `div.scheme .current` ) )
			{
				chooserSection.querySelector( `div.scheme .current` ).classList.remove( 'current' );
			}

			chooserSection.querySelector( `div.scheme #BLD-${searchParameters.building}` ).classList.add( 'current' );
		}

		Array.from( view.querySelectorAll( 'path[id*="FLOOR-"]' ) ).forEach( ( it ) => {
			it.addEventListener( 'mouseenter', highlightFloor );
			it.addEventListener( 'mousemove', moveTooltip );
			it.addEventListener( 'mouseleave', hideTooltip );
			it.addEventListener( 'click', selectFloor );
		} );

		Array.from( chooserSection.querySelectorAll( 'div.scheme [id*="BLD-"]' ) ).forEach( ( it ) => {
			it.addEventListener( 'click', selectBuilding );
			it.removeEventListener( 'click', switchBuilding );
		} );
	};

	const showComplex = () => {
		chooserSection.dataset.step = 'complex';
		chooserSection.querySelector( 'a.back' ).href = `/complex/${chooserData.complex.alias}/`;
		chooserSection.querySelector( 'li.info' ).innerHTML = '';
		chooserSection.querySelector( 'li.complex' ).innerHTML = '';
		chooserSection.querySelector( 'li.building' ).innerHTML = '';
		chooserSection.querySelector( 'span.title' ).innerHTML = 'очередь';
		chooserSection.querySelector( 'span.current-location' ).innerHTML = chooserData.complex.title;
		view.innerHTML = chooserData.complex.rendered + `<ul class="labels">${Object.values( chooserData.complex.levels ).map( ( level ) => `<li data-id="${level.id}"><strong>${level.title}</strong> <span class="deadline">${level.built_title}: ${level.built}</span></li>` ).join( '' )}</ul>`;
		placeLabels();
		
		if ( chooserSection.querySelector( `div.scheme .current` ) )
		{
			chooserSection.querySelector( `div.scheme .current` ).classList.remove( 'current' );
		}

		Array.from( view.querySelectorAll( 'path.building' ) ).forEach( ( it ) => {
			it.addEventListener( 'mouseenter', highlightBuilding );
			it.addEventListener( 'mousemove', moveTooltip );
			it.addEventListener( 'mouseleave', hideTooltip );
			it.addEventListener( 'click', selectBuilding );
		} );

		Array.from( chooserSection.querySelectorAll( 'div.scheme [id*="BLD-"]' ) ).forEach( ( it ) => {
			it.addEventListener( 'click', selectBuilding );
			it.removeEventListener( 'click', switchBuilding );
		} );
	};

	const showFloor = () => {
		if ( !chooserData.floor.premises_count[searchParameters.floor] )
		{
			const minFloor = Object.keys(chooserData.floor.premises_count)[0];
			
			selectFloor( minFloor );
			return;
		}
		
		const floors = chooserData.floor.premises_count;

		delete floors.all;
		chooserSection.dataset.step = 'floor';
		chooserSection.dataset.building = searchParameters.building || 0;
		chooserSection.dataset.floor = searchParameters.floor;
		chooserSection.querySelector( 'li.info' ).innerHTML = `${chooserData.floor.breadcrumbs[0].title}`;
		chooserSection.querySelector( 'li.complex' ).innerHTML = 'Выбор очереди';
		chooserSection.querySelector( 'li.building' ).innerHTML = chooserData.floor.breadcrumbs[1].title === 'Срок сдачи' ? '' : 'Выбор этажа';
		chooserSection.querySelector( 'span.title' ).innerHTML = 'квартиру';
		chooserSection.querySelector( 'span.current-location' ).innerHTML = searchParameters.floor + '&nbsp;этаж';
		view.innerHTML = chooserData.floor.layout_rendered;
		chooserSection.querySelector( 'ul.floors' ).innerHTML = `<li class="prev${Object.keys( floors )[0] === searchParameters.floor ? '  disabled' : ''}"></li>${getFloors( floors, searchParameters.floor ).map( ( floor ) => `<li${floor === searchParameters.floor ? ' class="current"' : ''} data-floor="${floor}"${floors[floor].count === 0 ? ' disabled' : ''}>${floor}</li>` ).join( '' )}<li class="next${Object.keys( floors )[Object.keys( floors ).length - 1] === searchParameters.floor ? '  disabled' : ''}"></li>`;
		
		if ( chooserData.floor.breadcrumbs[1].title !== 'Срок сдачи' )
		{
			if ( chooserSection.querySelector( `div.scheme .current` ) )
			{
				chooserSection.querySelector( `div.scheme .current` ).classList.remove( 'current' );
			}

			chooserSection.querySelector( `div.scheme #BLD-${searchParameters.building}` ).classList.add( 'current' );
		}

		Array.from( view.querySelectorAll( '[id*="APT-"]' ) ).forEach( ( it ) => {
			const requestedID = it.id.replace( 'APT-', '' );
			const apartment = chooserData.floor.rooms.find( ( room ) => room['position_on_floor'] === requestedID );

			if ( apartment && apartment.enabled )
			{
				it.dataset.enabled = 'yes';
				it.dataset.title = apartment.title;
			}
		} );

		Array.from( view.querySelectorAll( '[id*="APT-"]' ) ).forEach( ( it ) => {
			it.addEventListener( 'mouseenter', highlightApartment );
			it.addEventListener( 'mousemove', moveTooltip );
			it.addEventListener( 'mouseleave', hideTooltip );
			it.addEventListener( 'click', selectApartment );
		} );

		Array.from( chooserSection.querySelectorAll( 'div.scheme [id*="BLD-"]' ) ).forEach( ( it ) => {
			it.removeEventListener( 'click', selectBuilding );
			it.addEventListener( 'click', switchBuilding );
		} );

		updateCriteo( chooserData.floor.rooms.filter( ( room ) => room.enabled ).map( ( room ) => room.id ), 'viewList' );
		
		offsetLegend( chooserSection, view, chooserData.id_complex );
	};

	const switchBuilding = ( evt ) => {
		selectBuilding( evt, true );
	};

	const floors = chooserSection.querySelector( 'ul.floors' );
	
	if ( floors )
	{
		floors.addEventListener( 'click', ( evt ) => {
			if ( evt.target.tagName.toLowerCase() !== 'li' )
			{
				return;
			}
	
			let requestedFloor = evt.target.innerHTML;
	
			if ( requestedFloor === '' )
			{
				const availableFloors = Object.keys( chooserData.floor.premises_count );
				let direction = evt.target.classList.contains( 'next' ) ? 1 : -1;
	
				requestedFloor += availableFloors[availableFloors.indexOf( searchParameters.floor ) + direction];
			}
	
			if ( requestedFloor !== '' )
			{
				selectFloor( requestedFloor );
			}
		} );
	}

	fullSearchParameters['ajax_component'] = componentID;

	const url = location.pathname + stringifySearchParameters( fullSearchParameters );

	getData( url );
	handleResize();
	window.addEventListener( 'resize', handleResize );
	/* Сдвиг легенды этажа при изменени размера окна */
	window.addEventListener( 'resize', () => {
		if ( chooserData && chooserData.floor )
		{
			offsetLegend( chooserSection, view, chooserData.id_complex );
		}
	} );
};
